import queryString from 'query-string';
import React from 'react';
import { useLocation } from 'react-router-dom';
import PlacementExamViewSubmissions from './PlacememtExamViewSubmissions';

const PlacememtExamViewSubmissionsOwe = (props) => {
  const location = useLocation();
  const search = queryString.parse(location.search);
  const districtOrgIdOverride =
    search?.org_id != null && String(search.org_id).trim() !== ''
      ? String(search.org_id)
      : undefined;
  return (
    <PlacementExamViewSubmissions
      {...props}
      districtOrgIdOverride={districtOrgIdOverride}
    />
  );
};

export default PlacememtExamViewSubmissionsOwe;
